export default __webpack_public_path__ + "static/media/(40).befeb874.jpg";